import React from 'react';
import { COLORS } from '../../styles/variables';

interface ArrowProps {
  size?: number;
  color?: string;
}

const ArrowLeftIcon: React.FC<ArrowProps> = ({ size = 24, color = COLORS.grey60 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.9849 17.439L9.49994 11.996L14.9799 6.56103" stroke={color} />
    </svg>
  );
};

export default ArrowLeftIcon;
